import { Component, OnInit } from '@angular/core';
import { MnFullpageService, MnFullpageOptions } from 'ngx-fullpage';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent {

  innerHeight: any;
  autoScroll = true;

  options: MnFullpageOptions = new MnFullpageOptions(
    {
      autoScrolling: this.getAutoScroll(),
      fitToSection: this.getAutoScroll(),
      fixedElements: '#header',
      scrollingSpeed: 1500,
      navigation: true,
      menu: '#header',
      anchors: [
        'home', 'empresa', 'cobertura', 'servicios', 'galeria', 'contacto'
      ],
      keyboardScrolling: true,
      afterLoad: function(anchorLink, index){
      }
    }
  );

  initAnimaciones(anchorLink: any, index: any) {
    console.log('initAnimaciones');
    console.log('anchorLink' + anchorLink);
    console.log('Index' + index);
  }

  constructor() { }

  getAutoScroll() {
    if (window.screen.height < 768 ) {
      return false;
    }else {
      return true;
    }
  }

}



// WEBPACK FOOTER //
// C:/Front-end/[PROYECTO] abordo-empresarial-cli4/[RAMA] actualizarAngular-Analytics/abordo-empresarial-cli4/src/app/app.component.ts